import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SettingsPage() {
    return (_jsxs("div", { className: "page", children: [_jsxs("header", { className: "page-header", children: [_jsx("h2", { children: "Settings" }), _jsx("p", { className: "page-subtitle", children: "Account and preferences" })] }), _jsx("div", { className: "placeholder-card", children: _jsx("p", { children: "Account settings coming soon." }) })] }));
}
